import Formsy from 'formsy-react';
import React from 'react';
import {Input} from '../form';
import {updateUser} from '../../actions/UserActions'
import AppState from '../../state/AppState'

class EditUserForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      message: null,
      messageIsError: false,
      isPristine: true
    };

  }

  onValidSubmit(model) {

    const { isPristine } = this.state;
    if (isPristine) return;

    this.setState({isProcessing: true, message: null});

    updateUser(model.first, model.last, model.email)
      .then((result) => {
        this.setState({
          isProcessing: false,
          message: "Your changes were applied successfully.",
          messageIsError: false
        });
      })
      .catch((e) => {
        this.setState({
          isProcessing: false,
          message: e.message,
          messageIsError: true
        });
      });

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, message, messageIsError, isPristine } = this.state;
    const { user } = this.props.AppState;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onChange={(values, isChanged) => this.checkForPristine(values, isChanged) }
              onInvalidSubmit={() => this.onInvalidSubmit() }
              ref="form">
        <div className="form-fields">
          <Input name="email"
                 type="email"
                 icon="build"
                 value={user.email}
                 label="Email"
                 showErrors={showErrors}
                 autoComplete="off"
                 required />
          <Input name="first"
                 type="text"
                 icon="build"
                 value={user.first}
                 label="first name"
                 autoComplete="off"
                 showErrors={showErrors}
                 required />
          <Input name="last"
                 type="text"
                 icon="build"
                 value={user.last}
                 label="Last name"
                 autoComplete="off"
                 showErrors={showErrors}
                 required />
          </div>
          <div className="form-submit-group grid-row">
            <div className="grid-item grid-row v-align">
              {message && (
                <div className={"message" + (messageIsError ? " error-message" : "")}>
                  {message}
                </div>
              )}
            </div>
            <div>
              <button className={"pt-button sr2" + (isPristine ? " pt-disabled" : "")}
                      type="button"
                      onClick={() => this.onCancel() }>Cancel</button>
              {!isProcessing ? (
                <button type="submit"
                        className={"pt-button pt-intent-primary" + (isPristine ? " pt-disabled" : "")}>Submit</button>
              ) : (
                <button type="submit"
                        className="pt-button pt-disabled ">Submitting...</button>
              )}
            </div>
          </div>
      </Formsy>
    );
  }

  checkForPristine(values, isChanged) {
    this.setState({isPristine: !isChanged, message: null});
  }

  onCancel() {

    const { isPristine } = this.state;
    if (isPristine) return;

    this.refs.form.reset();
    this.setState({
      message : "Your changes have been discarded.",
      messageIsError: false
    });
  }
}

export default AppState.connect(React, EditUserForm);



// WEBPACK FOOTER //
// ./src/components/forms/EditUserForm.js